import request from '@/api/request'
// 获取个人信息
export const getUserInfo = (data) => {
  return request({
    url: '/v1/manager/system/user/info/',
    method: 'post',
    data: data
  })
}
// 保存个人信息
export const saveUserInfo = (data) => {
  return request({
    url: '/v1/manager/system/user/info/save',
    method: 'post',
    data: data
  })
}

// 修改密码
export const updatePassword = (data) => {
  return request({
    url: '/v1/manager/system/user/info/change',
    method: 'post',
    data: data
  })
}
